export const shipping_payments = "shipping_payments"